import { customAppsActions } from '../modules/customApps';
const { fetchCustomApps } = customAppsActions;

export default (store: any) => (next: any) => (action: any) => {
  const actionResult = next(action);
  if (action.type.indexOf('SET_ACTIVE_ACCOUNT') > -1) {
    store.dispatch(fetchCustomApps());
  }
  return actionResult;
};
